import React, { useEffect, useState } from 'react'
import { NumberFormatBase } from 'react-number-format';
import { Field } from "formik";
import "../style.scss";
import {
  FormControl,
  FormLabel,
  Input,
  Box,
  FormErrorMessage

} from "@chakra-ui/react";
import { EditFormIcon } from '~misc/icons';
import useModalPrice from '~components/Modal/hooks/useModalPrice';
import ModalPriceSearch from '~components/Modal/ModalPriceSearch';
import { removingFormatting } from '~services/GlobalServices';

const PriceInput = ({ inputName, inputMask, inputType, as, mask, labelName, setValue,setInput, input , values, onBlur, isDisabled, hasImage, setFieldValue, defaultValue, setFieldTouched, handleValue }) => {
  const { isModalOpenPrice, closeModalPrice, openModalPrice } = useModalPrice();
  const [isImageVisible, setIsImageVisible] = useState("true");
  const [error, setError] = useState();
  const [defaultValueChange, setDefaultValueChange] = useState(false);


  useEffect(() => {
    if (error == "volume/preço menor ou igual a zero") {
      openModalPrice();
    }
  }, [error])



  function currencyFormatter(value) {
    if (value === null || value === undefined || isNaN(Number(value))) {
      return 0;
    }

    const amount = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    }).format(value / 100);

    return `${amount}`;
  }

  useEffect(()=>{
    if(defaultValue != undefined && defaultValue > 0 && !defaultValueChange){
      let formatValue = currencyFormatter(defaultValue)
      setFieldValue(inputName,  formatValue)
      setDefaultValueChange(true);
      if(setFieldTouched){
        setTimeout(() =>  setFieldTouched(inputName, true))
      }
    }
  }, [defaultValue])

  return (
    <>
      <Field name={inputName} >
        {({ field, meta }) => (
          <FormControl isInvalid={meta.error && meta.touched} className={isDisabled == true ? "desabilitar" : "normal" }>
            <FormLabel className="field__label">{labelName}</FormLabel>
            <Box position="relative">
              <Input className='search-wrapper searchWrapper' type={inputType}

              as={NumberFormatBase}
              format={currencyFormatter}
                {...field}
                 onChange={(e) => {
                field.onChange(e);
                if(handleValue){
                  handleValue(e.target.name, e.target.value)
                }
                if (values)
                  setValue({ ...values, name: e.target.name, value: e.target.value })

                  const inputValue = e.target.value;
                  setInput(removingFormatting(inputValue))
              }}
                onBlur={(e) => {
                  field.onBlur(e);
                  setIsImageVisible(true);
                }}
                onClick={(e) => {
                  setIsImageVisible(false);
                }}
                disabled={isDisabled ? isDisabled : false}
              />
              {hasImage && isImageVisible && (

                <span style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}>
                  <EditFormIcon />
                </span>
              )}
            </Box>
            {/* {meta.touched && meta.error && setError(meta.error)} */}
            {meta.touched && meta.error && (
              <FormErrorMessage>{meta.error}</FormErrorMessage>
            )}
            <ModalPriceSearch
              isOpen={isModalOpenPrice}
              onClose={() => {

                closeModalPrice();
              }}
              title="Aviso!"
              sub={<>
                <p className="font-bold max-w-[200px]">volume/preço menor ou igual a zero</p>
              </>}
              buttonOne={null}
              buttonTwo="Ok"
              linkOne={null}
              linkTwo={null}
            />
          </FormControl>
        )}
      </Field>
    </>
  )
}

export default PriceInput;
